<template>
  <v-dialog v-model="modelValue" width="unset" max-width="500px">
    <template v-slot:activator="{ on, attrs }">
      <slot name="activatorButton" :on="on" :attrs="attrs" />
    </template>
    <div class="dialog-card">
      <v-card-title
        ><v-row>
          <slot name="icon" />
          <span class="dialog-card-title">{{ title }}</span>
        </v-row>
      </v-card-title>

      <div class="dialog-card-content">
        <slot name="content" />
      </div>
      <v-col class="pt-3">
        <v-row v-if="primaryButtonText">
          <CustomThemedButton
            class="main-button"
            rounded
            :disabled="mainButtonDisabled"
            block
            @click="onPrimaryButtonPressed()"
          >
            {{ primaryButtonText }}
          </CustomThemedButton>
        </v-row>
        <v-row>
          <v-btn
            color="primary"
            text
            rounded
            block
            @click="onCancelButtonPressed()"
          >
            {{ onCancelButtonText || "Cancel" }}
          </v-btn>
        </v-row>
      </v-col>
    </div>
  </v-dialog>
</template>
    
<script>
import CustomThemedButton from "@/core/CustomThemedButton.vue";
export default {
  name: "BaseDialogCard",
  components: {
    CustomThemedButton,
  },
  props: {
    onPrimaryButtonPressed: Function,
    onCancelButtonPressed: Function,
    primaryButtonText: String,
    title: String,
    dialogModel: Boolean,
    mainButtonDisabled: {
      type: Boolean,
      default: false,
    },
    onCancelButtonText: String,
  },
  computed: {
    modelValue: {
      get() {
        return this.dialogModel;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  data: function () {
    return {};
  },
};
</script>

<style scoped>
.dialog-card {
  background-color: var(--color-bg);
  border-radius: 10px;
  padding: 10px;
  border: 1px solid var(--color-secondary);
}

.dialog-card-content {
  overflow-y: auto;
  max-height: 50vh;
}

.dialog-card-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text);
}
</style>
